import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'
import networkConfig from '@/config/default/net.config'
import { ErrorResult } from '@/model/ErrorResult'
import router from '@/router'

// 配置新建一个 axios 实例
// 判断是否是生产环境
const isPro = process.env.NODE_ENV === 'production' // process.env.NODE_ENV用于区分是生产环境还是开发环境

export const BASE_URL: string = isPro ? `${window.location.origin}/api` : '/apis/'

const service: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: networkConfig.timeout,
  headers: { 'Content-Type': 'application/json' }
})

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers.common['X-APP-ID'] = 'WEB'
    // if (getToken()) {
    //   config.headers.common.Authorization = getToken()
    // }
    if (config.method === 'post' || config.method === 'put') {
      config.headers['Content-Type'] = 'application/json'
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  <T = ErrorResult | any>(response: AxiosResponse<T>): Promise<AxiosResponse<T>> => {
    if (response.status && response.status >= 200 && response.status < 300) {
      return Promise.resolve(response)
    } else {
      const result = response.data as ErrorResult
      ElMessage({
        type: 'error',
        message: result.message
      })
      return Promise.reject(result.message)
    }
  },
  (error) => {
    if (error.message.indexOf('timeout') !== -1) {
      ElMessage.error('网络超时')
    } else if (error.message === 'Network Error') {
      ElMessage.error('网络连接错误')
    } else {
      const response: AxiosResponse<ErrorResult> = error.response

      if (response) {
        const result = response.data

        if (!result.errors || !result.errors.length) {
          switch (response.status) {
            case 401:
              // 直接去登陆页面，不提示
              if (!window.location.href.includes('login')) {
                router.push('/login')
              }
              break
            case 403:
              return Promise.reject(ElMessage({
                type: 'error',
                message: response.data.message || '暂无权限！'
              }))
            case 400:
              return Promise.reject(ElMessage({
                type: 'error',
                message: response.data.message
              }))
            default:
              return Promise.reject(ElMessage({
                type: 'error',
                message: response ? response.data.message : '接口异常'
              }))
          }
        }
      } else {
        return Promise.reject(ElMessage({
          type: 'error',
          message: '接口异常'
        }))
      }
    }

    return Promise.reject(error.response?.data)
  }
)

// axios 默认返回的是Promise<AxiosResponse<T>>,实际需要的是Promise<T>
const httpClient = async <R = any>(config: AxiosRequestConfig): Promise<R> => {
  const response: AxiosResponse<R> = await service(config)
  return Promise.resolve(response.data)
}

// 导出 axios 实例
export default httpClient
